import moment from "moment";

const getStartsAt = date => moment(date).format("DD/MM/Y [às] HH[h]");
const getDate = date => moment(date).format("DD/MM/Y");
const getNameDay = date => moment(date).format("dddd");
const getHour = date => moment(date).format("HH");

export default {
  getStartsAt,
  getDate,
  getNameDay,
  getHour
};



// WEBPACK FOOTER //
// ./src/utils/helpers/date.js